import { Audit } from "../audit";
import { AuditResultListSummary } from "./audit-result-list-summary";

export class PagedAuditResultList {
    public Results: Audit[] = [];
    public Summary: AuditResultListSummary = new AuditResultListSummary();
    public PageNumber: number = 1;
    public PageSize: number = 25;
    public TotalCount: number = 0;

    constructor(values: Object = {}) {
        Object.assign(this, values);
        this.Results = ((values as PagedAuditResultList).Results || []).map(a => new Audit(a));
        this.Summary = new AuditResultListSummary((values as PagedAuditResultList).Summary || {});
    }
}
